import * as React from 'react'
import CloudinaryImage from 'web-makeup/dist/CloudinaryImage'
import { Margin } from 'web-makeup/dist/design-system/styles/spacings'
import { Text } from 'web-makeup/dist/design-system/styles/typography'
import { OptionalFlex } from 'web-makeup/dist/styles/layout'

import StyledCheckbox from '../StyledCheckbox/StyledCheckbox'

import { Wrapper, Logo, AddButton } from './IntegrationBar.style'

export interface IntegrationBarProps {
  onClick?: () => void
  checked?: boolean
  isDefault?: boolean
  title?: string
}

const IntegrationBar: React.FC<IntegrationBarProps> = ({ onClick, isDefault, checked, title }) => {
  return (
    <>
      <Wrapper>
        <OptionalFlex flex alignHorizontally="space-between">
          <Text as="div" fontSize="h2" fontWeight="black" color="black1">
            {title}
          </Text>
          <OptionalFlex flex alignHorizontally="flex-end">
            {checked && (
              <Margin right size="mSmall">
                {isDefault ? (
                  <Text as="div" fontSize="h5" fontWeight="bold" color="saruman">
                    Default channel
                  </Text>
                ) : (
                  <Text
                    as="div"
                    fontSize="h5"
                    fontWeight="bold"
                    color="black1"
                    onClick={() => alert('Make default action')}
                  >
                    Make default
                  </Text>
                )}
              </Margin>
            )}
            <Margin right size="mSmall">
              <Text as="div" fontSize="h5" fontWeight="bold" color="black1">
                Integrated
              </Text>
            </Margin>
            <StyledCheckbox checked={checked} onClick={onClick} />
          </OptionalFlex>
        </OptionalFlex>
        {checked && (
          <OptionalFlex flex>
            <Logo>
              <CloudinaryImage
                useSourceFormat
                source={{
                  id: 'v1567750477/-homepage-icons/-brands/logo-unilever.svg',
                  type: 'upload',
                }}
              />
            </Logo>
            <div>
              <Text as="div" fontSize="h4" fontWeight="bold" color="black1">
                MKTG YouTube
              </Text>
              <Text as="div" fontSize="h6" color="black1">
                76 videos
              </Text>
            </div>
          </OptionalFlex>
        )}
      </Wrapper>
      {checked && (
        <AddButton>
          <CloudinaryImage
            useSourceFormat
            source={{
              id: 'v1609821297/-design-system/icon-add-more-blue.svg',
              type: 'upload',
            }}
          />
        </AddButton>
      )}
    </>
  )
}

export default IntegrationBar



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/IntegrationBar/IntegrationBar.tsx